/* eslint-disable */
import Button from "../Button";
import cn from 'classnames';
import './Prompt.scss';
import { useEffect, useRef } from "react";

/**
 * @param {{
 *   onSelect: (optionId: string|number) => void;
 *   onDismiss: () => void;
 *   icon?: JSX.Element;
 *   children: React.ReactNode;
 *   options: Array<{
 *     id: string|number;
 *     content: string;
 *     secondary?: boolean;
 *   }>;
 * }} props
 */
const Prompt = ({
  onSelect,
  onDismiss,
  options,
  icon,
  children,
}) => {
  const modalBodyRef = useRef(document.createElement('div'));

  // Focus modal when opened
  useEffect(() => {
    const lastFocus = document.activeElement;
    modalBodyRef.current.focus();
    return () => {
      lastFocus?.focus?.();
    }
  }, []);

  return (
    <div className="Prompt">
      <div className="Prompt__Vignette" onClick={onDismiss} />
      <div className="Prompt__Modal">
        <div ref={modalBodyRef} className={cn({
          'Prompt__Body': true,
          'Prompt__Body--no-icon': !icon,
        })}>
          {icon && (
            <div className="Prompt__Icon">{icon}</div>
          )}
          <p className="Prompt__Content">{children}</p>
        </div>
        <div className="Prompt__Options">
          {options.map(option =>
            <Button
              key={option.id}
              className="Prompt__Option"
              variation={option.secondary ? 'secondary' : 'primary'}
              onClick={() => onSelect(option.id)}
              children={option.content}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Prompt;
